import { Table, Divider, Typography, Popconfirm, Button, Input } from "antd"
import React from "react"
import { ElementLoader } from "../../../components/ElementLoader"
import { TableSearch } from "../../../components/utils/TableSearch"
import { useAuthContext } from "../../../hooks/useAuthContext"
import { useCollection } from "../../../hooks/useCollection"
//Renames Router Dom "Link" as Direction
import { Link as Direction } from "react-router-dom"
import moment from "moment"
import { BackwardOutlined, DeleteOutlined } from "@ant-design/icons"
import { deleteDoc, doc } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { Notification } from "../../../components/Notification"

const { Title, Text } = Typography
const { TextArea } = Input

export default function SentBackPrices() {
  //loads the user
  const { user } = useAuthContext()

  //loads the data
  const { data, loading } = useCollection(
    "priceCalculation",
    ["user", "==", user.uid],
    ["sentBack", "==", true]
  )

  //elemnt loading
  const elementLoading = ElementLoader(loading)

  //deleting the price
  const deleteData = async (e, docid) => {
    e.preventDefault()

    //price ref
    const ref = doc(db, "priceCalculation", docid)

    //deletes the price
    await deleteDoc(ref)
      .then(() => {
        Notification("warning", "Deleted!", "Price has been deleted!")
      })
      .catch((err) => {
        Notification("error", "Login Error", err.message)
      })
  }

  //these are filters for table
  let priceFilter =
    data &&
    Array.from(
      new Set(
        data
          .map((item) => {
            if (item.hasFilterGroup === true) {
              return item.filterGroupId
            }
            return undefined
          })
          .filter((item) => item !== undefined)
      )
    ).map((filterGroupId) => ({
      text: data.find((item) => item.filterGroupId === filterGroupId).filterGroup,
      value: filterGroupId,
    }))

  //product filters
  let productFilters =
    data &&
    data.map((item) => {
      return {
        text: item.product.productName,
        value: item.id,
      }
    })

  //Controls the state of columns
  const columns = [
    {
      title: "Clients",
      dataIndex: "client",
      ...TableSearch("client"),
    },
    {
      title: "Filter Group",
      dataIndex: "filterGroup",
      align: "center",
      filters: priceFilter,
      onFilter: (value, record) => {
        if (record.hasFilterGroup) {
          return record.filterGroupId === value
        }
      },
      render: (value, record) => {
        if (record.hasFilterGroup) {
          return record.filterGroup
        } else {
          return "none"
        }
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      sorter: (a, b) => a.price - b.price,
      render: (text, value) =>
        value.advanced.fixedPrice === true ? (
          <>
            <Text code italic type="danger">
              {value.totalFixedPrice}
            </Text>
          </>
        ) : (
          text
        ),
    },
    {
      title: "Comment from admin",
      dataIndex: "adminComment",
      width: "15%",
      render: (text, value) => <Text style={{ color: "red" }}>{text}</Text>,
    },
    {
      title: "Product",
      dataIndex: ["product", "productName"],
      align: "center",
      width: "20%",
      filters: productFilters,
      onFilter: (value, record) => {
        return record.id === value
      },
    },
    {
      title: "Width",
      dataIndex: "labelWidth",
      sorter: (a, b) => a.labelWidth - b.labelWidth,
    },
    {
      title: "Height",
      dataIndex: "labelHeight",
      sorter: (a, b) => a.labelHeight - b.labelHeight,
    },
    {
      title: "Material",
      dataIndex: "material",
      sorter: (a, b) => a.material - b.material,
    },
    {
      title: "Count",
      dataIndex: "labelCount",
      sorter: (a, b) => a.labelCount - b.labelCount,
    },
    {
      title: "Details",
      align: "center",
      render: (value) => (
        <Text>
          <Direction state={value} to="/calculations">
            View Price
          </Direction>
        </Text>
      ),
    },
    {
      title: "Details",
      align: "center",
      render: (value) => (
        <Text>
          <Popconfirm
            onConfirm={(e) => deleteData(e, value.id)}
            title="Are you sure you want to delete?"
            okText="Yes"
            cancelText="No">
            <Button type="text" danger>
              Delete
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Text>
      ),
    },

    {
      title: "Created",
      dataIndex: ["date", "created"],
      sorter: (a, b) => a.date.create.seconds - b.date.create.seconds,
      render: (value) => (
        <>
          <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
        </>
      ),
    },
  ]

  return (
    <div style={{ marginTop: "15px" }}>
      <Title level={3} style={{ marginLeft: "18px" }}>
        <BackwardOutlined /> <Divider type="vertical" />
        Sent Back Prices
      </Title>
      <Text style={{ marginLeft: "18px" }} type="secondary">
        These are prices that has not been accepted by admin and has been sent back with a comment.
      </Text>
      <Table
        bordered
        style={{ margin: "15px" }}
        size="small"
        columns={columns}
        loading={elementLoading}
        dataSource={data && data}
        rowKey={(record) => record.id}
        pagination={{ defaultPageSize: "15" }}
      />
    </div>
  )
}
